import { EntityValidationResponse } from '@epicuro-next/data/engagement/document-control/models';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { patchValidatorsSuccess, upsertValidators } from '../../actions';

export const validatorsFeatureKey = 'validators';

export interface State extends EntityState<EntityValidationResponse> {}

export const adapter: EntityAdapter<EntityValidationResponse> =
  createEntityAdapter<EntityValidationResponse>({
    selectId: (entity) => entity.entityId,
  });

export const initialState: State = adapter.getInitialState({
  loading: false,
});

const validatorsReducer = createReducer(
  initialState,
  on(
    upsertValidators,
    patchValidatorsSuccess,
    (state, { type, ...payload }) => {
      return adapter.upsertOne(payload, state);
    },
  ),
);

export function reducer(state: State | undefined, action: Action) {
  return validatorsReducer(state, action);
}
